import { BrowserRouter, useLocation } from "react-router-dom";
import {
  listenForegroundMessage,
  requestNotificationPermission,
} from "notificationService";
import { useEffect } from "react";
import { AxiosInterceptor } from "./services";
import Router from "./routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "pages/profile/paymentMethods/stripe";
import RouteApiListener from "RouteApiListener";
import ScrollToTop from "component/ui/ScrollToTop";

function App() {
  useEffect(() => {
    listenForegroundMessage();
    requestNotificationPermission();
  }, []);
  return (
    <>
      {/* <PushNotifications /> */}
      <ToastContainer />
      <Elements
        stripe={stripePromise}
        options={{
          disableLink: true,
        }}
      >
        <BrowserRouter>
          <AxiosInterceptor>
            <ScrollToTop/>
            <RouteApiListener />
            <Router />
          </AxiosInterceptor>
        </BrowserRouter>
      </Elements>
    </>
  );
}

export default App;
